<template>
  <div class="toast-item">
    <div class="item-icon">
      <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10.5001" cy="10.4998" r="8.33333" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5001 18.8332C15.1025 18.8332 18.8334 15.1022 18.8334 10.4998C18.8334 5.89746 15.1025 2.1665 10.5001 2.1665C5.89771 2.1665 2.16675 5.89746 2.16675 10.4998C2.16675 15.1022 5.89771 18.8332 10.5001 18.8332ZM13.1967 7.60267C13.5119 7.26828 14.0959 7.33112 14.4199 7.60267C14.7817 7.90592 14.7147 8.40662 14.4199 8.71948L10.0142 13.3946C9.73121 13.6949 9.07257 13.7081 8.79102 13.3946L6.57733 10.9297C6.27002 10.5875 6.23467 10.1537 6.57733 9.81286C6.87205 9.51972 7.51239 9.49208 7.80047 9.81286L9.41732 11.6132L13.1967 7.60267Z" fill="#11BF88"/>
      </svg>
    </div>
    <div class="item-body">
      <span v-html="message"></span>
    </div>
    <button
      class="btn-toast-close"
      v-on:click="removeNoti"
    >
      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.5 2.5L14.5 14.4999M2.5 14.5L14.5 2.5" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timeout: null
    }
  },
  props: {
    message: String,
    id: [String, Number],
    createdAt: Number
  },
  mounted() {
    this.timeout = setTimeout(()=> {
      this.removeNoti()
    }, 5000)
  },
  beforeUnmount() {
    if (this.timeout != null) {
      console.log("clear")
      clearTimeout(this.timeout)
    }
  },
  methods: {
    removeNoti() {
      this.$store.dispatch('removeItem', this.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.toast-item {
  pointer-events: auto;
  width: 273px;
  min-height: 53px;
  box-shadow: 0px 8px 16px rgba(32, 32, 32, 0.15);
  background-color: var(--gray-800);
  padding: 0 16px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  color: white;
  font-size: 14px;
  gap: 16px;
}

.item-icon {
  width: 20px;
  height: 20px;
  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.item-body {
  flex: 1;
}

.btn-toast-close {
  cursor: pointer;
  display: block;
  outline: 0;
  background-color: transparent;
  margin: 0;
  padding: 0;
  border: 0;
  width: 16px;
  height: 16px;
  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>